import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { CommonModule } from '@angular/common';
import { ComponentsModule } from '../../components/components.module';
import { WalletNotActivePage } from './wallet-not-active';

@NgModule({
  declarations: [
    WalletNotActivePage,
  ],
  imports: [
    IonicPageModule.forChild(WalletNotActivePage),
    CommonModule,
    ComponentsModule,
  ],
})
export class WalletNotActivePageModule { }



// WEBPACK FOOTER //
// ./src/pages/wallet-not-active/wallet-not-active.module.ts